import newCellStatus from './newCellStatus.vue'
export default newCellStatus
